import { useMemo } from 'react'
import { computeBbb } from './ggBingoBangoBongo.js'
import { samplePlayers } from './ggSamplePlayers.js'

// G-BingoBangoBongo — isolated sandbox. Three points per hole (bingo = first on,
// bango = closest once all on, bongo = first in). GGS tracks these live; here a
// deterministic sample event list drives the totals (uses first three players).
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }

export default function GBingoBangoBongo() {
  const players = useMemo(() => samplePlayers().slice(0, 3), [])
  const [a, b, c] = players.map((p) => p.id)
  // Deterministic sample bingo/bango/bongo awards for a handful of holes.
  const events = [
    { bingo: a, bango: b, bongo: a },
    { bingo: c, bango: a, bongo: b },
    { bingo: b, bango: b, bongo: c },
    { bingo: a, bango: c, bongo: a },
  ]
  const rows = useMemo(() => computeBbb(players, events), [players])

  return (
    <div className="card">
      <p className="text-sm text-gray-500 mb-3">🏌️ Bingo (first on) · 📍 Bango (closest once all on) · 🕳️ Bongo (first in) — 1 point each, 3 per hole.</p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Pos', 'Player', 'Points'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>{rows.map((p, i) => (
          <tr key={p.id}><td style={cell}>{i + 1}</td><td style={cell}>{p.name}</td><td style={cell}><b>{p.points}</b></td></tr>
        ))}</tbody>
      </table>
    </div>
  )
}
